export default __webpack_public_path__ + "static/media/Pistol_9.e3401828.png";